export default __webpack_public_path__ + "static/media/tennis_racket.f16814da.svg";